import { render, staticRenderFns } from "./DoctorAvatarDeleteModal.vue?vue&type=template&id=2b9247c2&scoped=true"
import script from "./DoctorAvatarDeleteModal.vue?vue&type=script&lang=js"
export * from "./DoctorAvatarDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9247c2",
  null
  
)

export default component.exports